export const bookstoreI18n = {
  en: {
    menu: {
      templates: 'Templates'
    },
    templatesView: {
      template: 'Template',
      eduacContent: 'Eduac\'s content',
      institutionContent: 'Institution content'
    }
  },
  es: {
    menu: {
      templates: 'Plantillas'
    },
    templatesView: {
      template: 'Plantilla',
      eduacContent: 'Contenido de Eduac',
      institutionContent: 'Contenido de la institución'
    }
  }
};